var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSalaVip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "88A9611E-F63F-48F7-AD42-54DE5EC443FD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.home-aba/concursos",
    transform: "translate(-24.000000, -460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-sala-vip",
    transform: "translate(0.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "003-crown",
    transform: "translate(1.000000, 4.000000)",
    fill: "#1717CE",
    fillRule: "nonzero",
    stroke: "#1717CE",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6984116,3.19922167 C21.4385366,2.97836 21.0717983,2.93181778 20.7644428,3.08077 L16.061771,5.35997 L11.6492242,0.294995556 C11.4860289,0.107628889 11.2491421,0 11,0 C10.7508765,0 10.5140328,0.107628889 10.3507945,0.294995556 L5.93824768,5.35992722 L1.23557585,3.08072722 C0.928220388,2.93181778 0.561525079,2.97831722 0.301564145,3.19917889 C0.0416032102,3.42004056 -0.0622092886,3.77329944 0.037177429,4.09883833 L3.30280239,14.7932828 C3.41284536,15.1536856 3.74666957,15.4 4.12500941,15.4 L17.8750093,15.4 C18.2533061,15.4 18.5871733,15.1536856 18.6971733,14.7933256 L21.9627983,4.09888111 C22.062228,3.77334222 21.9584155,3.42008333 21.6984116,3.19922167 Z M17.2379975,13.6888889 L4.76193519,13.6888889 L2.25466569,5.47778 L5.77904846,7.18593944 C6.12898595,7.35551056 6.54947814,7.26986944 6.80441173,6.97726944 L11.0000093,2.16134722 L15.1956499,6.97726944 C15.4505405,7.26991222 15.8711616,7.35546778 16.2209702,7.18593944 L19.745353,5.47778 L17.2379975,13.6888889 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSalaVip);
export default __webpack_public_path__ + "static/media/ic-sala-vip.c838e3a3402875bb13aa82751efd4b6d.svg";
export { ForwardRef as ReactComponent };